var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-dialog',{attrs:{"title":"Hướng dẫn tìm ID","visible":_vm.dialogVisible,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"img",attrs:{"src":_vm.gameImg,"alt":"","srcset":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }